import React from "react";
import BulkPaymentHero from "./bulk-payment/BulkPaymentHero";
import WorkSmarter from "./bulk-payment/WorkSmarter";
import JoinNetwork from "./bulk-payment/JoinNetwork";
import WorkPayment from "./bulk-payment/WorkPayment";
import svg98 from "../../../assets/svg/svg98.svg";   
import svg108 from "../../../assets/svg/svg108.svg"; 
import svg111 from "../../../assets/svg/svg111.svg";
import svg112 from "../../../assets/svg/svg112.svg";
import img7 from "../../../assets/img/img7.png";  
import svg116 from "../../../assets/svg/svg116.svg"; 
import svg118 from "../../../assets/svg/svg118.svg";
import svg119 from "../../../assets/svg/svg119.svg";
import svg120 from "../../../assets/svg/svg120.svg";
import svg121 from "../../../assets/svg/svg121.svg";
import svg122 from "../../../assets/svg/svg122.svg";
import svg123 from "../../../assets/svg/svg123.svg";
import svg124 from "../../../assets/svg/svg124.svg";

const itemsHero = [
  {
    title: "Instant Top-Ups",
    svg: svg98,
    desc: "Send airtime or data to one or hundreds of recipients in seconds no delays, no errors.",
  },
  {
    title: "Multi-Network Coverage",
    svg: svg118, 
    desc: "Support for all major mobile networks. Safaricom, Airtel, and Telkom for seamless nationwide reach.",
  },
  {
    title: "Flexible Disbursement",
    svg: svg119,
    desc: "Allocate top-ups by department, team, or project directly from your Ndovu Pay wallet.",
  },
];
const titleHero = "Keep Your Team Connected, Anytime";
const subtitleHero =
  "Distribute airtime and data bundles instantly to your staff, agents, or teams across all networks, from one easy-to-use dashboard.";

const itemsSmarter = [
  {
    title: "Multi-Network Support",
    svg: svg120,
    desc: "Digitize petty cash requests and approvals to remove manual handling and delays.",
  },
  {
    title: "Smarter Budgeting",
    svg: svg121,
    desc: "Monitor spending by department, set limits, and stay within budget effortlessly.",
  },
  {
    title: "Fast, Bulk Distribution",
    svg: svg122,
    desc: "Disburse funds instantly to teams and field agents, keeping operations moving.",
  },
  {
    title: "Controlled Disbursements",
    svg: svg116,
    desc: "Gain complete visibility. Every transaction is tracked, approved, and auditable.",
  },
    {
    title: "Real-Time Tracking",
    svg: svg123,
    desc: "Generate detailed reports in seconds for clear, compliant financial reviews.",
  },
];

const titleSmarter = "Built to Make Cash Management Effortless";
const subtitleSmarter =
  "Go digital, save time, and stay fully in control of your operational expenses.";

const itemsWorkPayment = [
  {
    svg: svg108,
    title: "Fund Your Wallet",
    desc: "Add funds via bank transfer or mobile money.",
  },
  {
    svg: svg124,
    title: "Upload Recipients",
    desc: "Add phone numbers manually or import a list via Excel or CSV.",
  },
  {
    svg: svg111,
    title: "Amounts & Networks",
    desc: "Approved requests are funded instantly via wallet or linked account.",
  },
  {
    svg: svg112,
    title: "Send Instantly",
    desc: "Distribute airtime or data bundles and track delivery in real time.",
  },
];

const titleWorkPayment = "How Bill Payments & Settlements Work";
const subtitleWorkPayment =
  "Process all your supplier and utility payments in four simple steps";
const title="Join the growing network of organizations using Ndovu Pay"
    const subtitle= "Experience the future of business payments with Ndovu Pay"
function Airtime({ setActive }) {
  return (
    <div id="airtime-data">
      <BulkPaymentHero
        items={itemsHero}
        title={titleHero}
        subtitle={subtitleHero}
        svg101={img7}
      />
      <WorkSmarter
        items={itemsSmarter}
        title={titleSmarter}
        subtitle={subtitleSmarter}
      />
      <WorkPayment
        items={itemsWorkPayment}
        title={titleWorkPayment}
        subtitle={subtitleWorkPayment}
      />
      <JoinNetwork title={title} subtitle={subtitle} setActive={setActive}/>
    </div>
  );
}

export default Airtime;
 